import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as staticContentActions } from '../../../actions/static_content'
import { actions as maintenanceActions } from '../../../actions/maintenance'


import { history } from '../../../store'
import {NavigationTo} from "../common";

import { Modal, ModalContent, ModalStyle } from '@amzn/stencil-react-components/modal'
import { Label, Text } from '@amzn/stencil-react-components/text'
import { Select } from '@amzn/stencil-react-components/form'
import { Col, Row } from '@amzn/stencil-react-components/layout'
import { Button, ButtonVariant } from '@amzn/stencil-react-components/dist/submodules/button'

class ChangeLanguageDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedLanguage: this.props.employee.language
    };
  }

  formatLanguagesOptions = (languages) => {
    return languages.map(language => ({ value: language.code, label: language.name}));
  }

  changeLanguageHandler = (selectedOption) => {
    this.setState({ selectedLanguage: selectedOption ? selectedOption.value : "" });
  }

  onYesButtonClicked = (callback) => {
    if (this.state.selectedLanguage != this.props.employee.language) {
      this.props.onCloseDialog();
      this.props.actions.employee.changeLanguageV2(this.state.selectedLanguage).then(_ => {
        this.props.actions.employee.load();
        this.props.actions.staticContent.load(this.state.selectedLanguage);
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.onOpenDialog();
    }
  }

  onOpenDialog = () => {
    this.setState({ selectedLanguage: this.props.employee.language });
  }

  render() {
    const { t } = this.props;
    const languageOptions = this.formatLanguagesOptions(this.props.configuration.languages);
    
    return (
        <Modal isOpen={this.props.visible} style={ModalStyle.Default} close={this.props.onCloseDialog} isScrollable={false}>
          <ModalContent
            titleText={t('ChangeLanguageDialog.HeaderLabel')}
            closeButtonAltText="Close Button For Change Language Dialog" 
            onCloseButtonClick={this.props.onCloseDialog}
            buttons={[
              <Button variant={ButtonVariant.Secondary} key='ChangeLanguageDialogCancelButton' onClick={this.props.onCloseDialog}>{t('ChangeLanguageDialog.CancelButton')}</Button>,
              <Button variant={ButtonVariant.Primary} disabled={this.state.selectedLanguage == this.props.employee.language} key='ChangeLanguageDialogYesButton' onClick={this.onYesButtonClicked}>{t('ChangeLanguageDialog.YesButton')}</Button>
            ]}
          >
           
              <Text>{t('ChangeLanguageDialog.PleaseChooseLabel')}</Text>
              <Col padding={{top: "S100"}}>
                <Label fontWeight="light" htmlFor="selected-language">{t('ChangeLanguageDialog.LanguageLabel')}</Label>
              <Select
                id="language-selection"
                options={languageOptions}
                renderOption={option => (
                  <Row alignItems="center" key={option.label}>
                    {option.label}
                  </Row>
                )}
                renderNativeOption={option => option.label}
                onChange={this.changeLanguageHandler}
                value={languageOptions.find(lang => lang.value == this.state.selectedLanguage)}
              />
              </Col>
          </ModalContent>
        </Modal>
      );
  }
}

const mapState = state => ({
  employee: state.employee,
  configuration: state.configuration
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    staticContent: bindActionCreators(staticContentActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch)
  }
});

export default connect(mapState, mapDispatchToProps)((withTranslation('translationsV2')(ChangeLanguageDialog)));
